import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';

const initState = {
    msgs: [],
    conversations: [],
    selectedConv: undefined,
    selectedMsg: undefined,
    selectedMsgAction: undefined,
    selectedMsgOpt: undefined,
    errorChat: null,
    errorMsg: null,
    errorSendMsg: null,
    loadingChat: false,
    loadingMsg: false,
    loadingSendMsg: false,
    loadedMsgCount: 0,
    loadedMsgFromPagingCount: 0,
    areMoreMsgToLoad: true,
    chatSelectedSenderName: null,
    chatSelectedChannelId: undefined,
    totalCountOfChats: 0,
    chatSelectedChannel: null,//Channel that selected
    completed: false,//In what section the agent
    isPublic: false,//In what section the agent  @@@@@@@@@@@@to test false
    multiSelectCount: 0,
    categoryUnSeenMsgsStatus: {
        newInquiries: 0,
        inProgressInquiries: 0,
        allAgentInquiries: 0
    }
}

const selectMsg = (state, action) => {
    let newSelectedMsg = action.selectedMsg
    let newSelectedMsgAction = action.selectedMsgAction
    let newSelectedMsgOpt = action.opt

    if (state.selectedMsg && state.selectedMsgAction) {
        if (!newSelectedMsg || (state.selectedMsg._id === newSelectedMsg._id && state.selectedMsgAction === action.selectedMsgAction)) {//its the same message + action => unselect
            newSelectedMsg = undefined
            newSelectedMsgAction = undefined
            newSelectedMsgOpt = undefined
        }
    }
    return updateObject(state, {
        selectedMsg: newSelectedMsg,
        selectedMsgAction: newSelectedMsgAction,
        selectedMsgOpt: newSelectedMsgOpt
    })
}


const fetchChatStart = (state, action) => {
    return updateObject(state, { errorChat: null, loadingChat: true });
}
const fetchChatSuccess = (state, action) => {
    return updateObject(state, {
        conversations: action.chats.chats.sort((a, b) => a.latestMsgTime < b.latestMsgTime ? 1 : a.latestMsgTime > b.latestMsgTime ? -1 : a.clientName < b.clientName ? 1 : -1),//.sort((a,b)=>a.latestMsgTime<b.latestMsgTime?1:-1),
        totalCountOfChats: action.chats.totalCountOfChats,
        errorChat: null,
        loadingChat: false
    });
}
const fetchChatUpdatedCrmDataSuccess = (state, action) => {
    return updateObject(state, {
        errorChat: null,
        loadingChat: false
    });
}


const fetchChatFail = (state, action) => {
    return updateObject(state, {
        errorChat: action.errorChat,
        loadingChat: false
    });
}

const fetchMsgStart = (state, action) => {
    return updateObject(state, { errorMsg: null, loadingMsg: true });
}

const fetchMsgSuccess = (state, action) => {//todo0403
    if (state.chatSelectedChannel !== action.channel || state.chatSelectedSenderName !== action.clientName || action.reloadChat) {
        const selectedChat = state.conversations.find(conv => conv.msgType === action.channel && conv.clientName === action.clientName)

        return updateObject(state, {
            msgs: action.msgs.sort((a, b) => a.msgTime >= b.msgTime ? 1 : -1),
            selectedConv: selectedChat,
            chatSelectedSenderName: action.clientName,
            chatSelectedChannel: action.channel,//Channel that selected
            errorMsg: null,
            loadingMsg: false,
            loadedMsgCount: action.newLoadedMsgCount,
            loadedMsgFromPagingCount: action.newLoadedMsgFromPagingCount,
            areMoreMsgToLoad: action.areMoreMsgToLoad,
            chatSelectedChannelId: action.chatSelectedChannelId
        });
    }
    else {
        if (state.loadedMsgFromPagingCount >= action.newLoadedMsgFromPagingCount) {
            return updateObject(state, {
                errorMsg: null,
                loadingMsg: false,
                areMoreMsgToLoad: action.areMoreMsgToLoad
            })
        }
        else {
            const newMsgs = [...action.msgs.sort((a, b) => a.msgTime >= b.msgTime ? 1 : -1), ...state.msgs]
            return updateObject(state, {
                msgs: newMsgs,
                errorMsg: null,
                loadingMsg: false,
                loadedMsgCount: action.newLoadedMsgCount,
                loadedMsgFromPagingCount: action.newLoadedMsgFromPagingCount,
                areMoreMsgToLoad: action.areMoreMsgToLoad
            });
        }
    }
}

// const chatSelected = (state, action) => {
//     //save chatObjAlone
//     const selectedChat=state.conversations.find(conv=>conv.msgType===action.chatSelectedChannel && conv.clientName===action.chatSelectedSenderName)
//     return updateObject(state, {
//         selectedConv:selectedChat,
//         chatSelectedSenderName: action.chatSelectedSenderName,
//         chatSelectedChannel: action.chatSelectedChannel,//Channel that selected
//     })
// }

const chatUnSelected = (state, action) => {

    return updateObject(state, {
        chatSelectedSenderName: undefined,
        chatSelectedChannel: undefined,//Channel that selected
        selectedConv: undefined,
        chatSelectedChannelId: undefined
    })
}

const fetchMsgFail = (state, action) => {
    return updateObject(state, {
        errorMsg: action.errorMsg,
        loadingMsg: false
    });
}
const sendMsgStart = (state, action) => {
    return updateObject(state, { errorSendMsg: null, loadingSendMsg: true });
}
const sendMsgSuccess = (state, action) => {
    //delete chat from public conversation
    const convs = [...state.conversations];
    const i = convs.findIndex(conv => (
        conv.clientName === action.msg.clientName && conv.msgType === action.msg.msgType //dima
    ));
    if (convs[i] && convs[i].isPublic === true) {
        convs.splice(i, 1);
    }
    //
    return updateObject(state, {
        conversations: convs,
        errorSendMsg: null,
        loadingSendMsg: false
    })
}
const sendMsgFail = (state, action) => {
    return updateObject(state, {
        errorSendMsg: action.errorSendMsg,
        loadingSendMsg: false
    });
}
const logout = (state, action) => {
    // return {
    //     msgs: [],
    //     conversations: [],
    //     errorChat: null,
    //     errorMsg: null,
    //     errorSendMsg: null,
    //     loadingChat: false,
    //     loadingMsg: false,
    //     loadingSendMsg: false
    // };
    return initState
}


const newMsgRecived = (state, action) => {
    let msgs = [...state.msgs]
    let newLoadedMsgCount = state.loadedMsgCount
    if (action.msg.msg.clientName === state.chatSelectedSenderName && action.msg.msg.msgType === state.chatSelectedChannel) {
        msgs = msgs.concat([action.msg.msg]);
        newLoadedMsgCount = newLoadedMsgCount + 1
    }

    return updateObject(state, {
        msgs: msgs,
        loadedMsgCount: newLoadedMsgCount
    })
}

const updateMsgRecived = (state, action) => {
    // console.log('@@@@@@')
    // console.log(action)
    const msgs = [...state.msgs]
    const chats = [...state.conversations]
    const msgIndex = msgs.findIndex(msg => {
        return msg._id === action.msg._id
    });
    if (msgIndex > -1) {
        msgs[msgIndex] = action.msg
        // msg.msgTime = action.msg.msg.msgTime;
        // msg.msg = action.msg.msg.msg;
        // msg.msgStatus = action.msg.msg.msgStatus;
    }
    if (action.chat) {
        const chatIndex = chats.findIndex(chat => {
            return chat._id === action.chat._id
        });
        if (chatIndex > -1) {
            chats[chatIndex] = action.chat
        }
    }
    return updateObject(state, {
        msgs: msgs,
        conversations: chats
    })
}


const deleteMsgRecived = (state, action) => {
    console.log('@@@@@@deleteMsgRecived')
    console.log(action)
    const msgs = [...state.msgs]
    const chats = [...state.conversations]
    const msgIndex = msgs.findIndex(msg => {
        return msg._id === action.msg._id
    });
    if (msgIndex > -1) {
        msgs.splice(msgIndex, 1);
    }
    if (action.chat) {
        const chatIndex = chats.findIndex(chat => {
            return chat._id === action.chat._id
        });
        if (chatIndex > -1) {
            chats[chatIndex] = action.chat
        }
    }
    return updateObject(state, {
        msgs: msgs,
        conversations: chats
    })
}

const updateConversations = (state, action) => {
    // console.log('updateConversations::')
    // console.log(action.conversation.chat)
    // console.log('updateConversations::state.isPublic')
    // console.log(state.isPublic)
    // console.log('updateConversations::state.completed')
    // console.log(state.completed)
    // console.log('action.chatTypeSelected')
    // console.log(action.chatTypeSelected)
    let convarr = [...state.conversations];
    let chatSelectedSenderName = state.chatSelectedSenderName
    let chatSelectedChannel = state.chatSelectedChannel
    let updatedSelectedConv = undefined

    //@@@check if to update selected chat@@@
    if (
        (
            state.selectedConv !== null &&
            state.selectedConv !== undefined &&
            action.conversation.chat.clientName === state.selectedConv.clientName &&
            action.conversation.chat.msgType === state.selectedConv.msgType
        )
        ||
        (
            state.msgs !== undefined &&
            state.msgs.length > 0 &&
            state.msgs[0].msgType === action.conversation.chat.msgType &&
            state.msgs[0].clientName === action.conversation.chat.clientName
        )
    ) {//add or update
        updatedSelectedConv = action.conversation.chat
    }

    //@@@check if update chat list@@@
    const conv = convarr.find(conv => (
        conv.clientName === action.conversation.chat.clientName && conv.msgType === action.conversation.chat.msgType
    ));

    if (conv) { //update or delete(if not in same category)
        if (
            (// same category
                conv.completed === action.conversation.chat.completed &&
                conv.isPublic === action.conversation.chat.isPublic &&
                (action.chatTypeSelected !== 7 || action.isAgentOnConvGroups)//Groups category and agent in the group of chat
            )
            ||
            (// open inquir
                action.chatTypeSelected === 4 && action.conversation.chat.completed === false
            )
            ||
            (// all inquir
                action.chatTypeSelected === 6
            )
        ) {
            conv.latestMsgTime = action.conversation.chat.latestMsgTime;
            conv.latestMsg = action.conversation.chat.latestMsg;
            conv.agentName = action.conversation.chat.agentName;
            conv.notSeenCount = action.conversation.chat.notSeenCount;
            conv.agentSeenCount = action.conversation.chat.agentSeenCount
            conv.crmId = action.conversation.chat.crmId
            conv.isPublic = action.conversation.chat.isPublic
            conv.completed = action.conversation.chat.completed
            conv.channelId = action.conversation.chat.channelId
            conv.channelName = action.conversation.chat.channelName
            conv.groupList = action.conversation.chat.groupList
            convarr.sort((a, b) => a.latestMsgTime < b.latestMsgTime ? 1 : a.latestMsgTime > b.latestMsgTime ? -1 : a.clientName < b.clientName ? 1 : -1)//.sort((a, b) => a.latestMsgTime <= b.latestMsgTime ? 1 : -1)
        }
        else {//delete chat
            const i = convarr.findIndex(conv => (
                conv.clientName === action.conversation.chat.clientName && conv.msgType === action.conversation.chat.msgType
            ));
            convarr.splice(i, 1);
        }
    }//insert conv
    else if ((state.isPublic === action.conversation.chat.isPublic && state.completed === action.conversation.chat.completed)//same category as selected
        ||
        action.chatTypeSelected === 6 // all inquiries
        ||
        (action.chatTypeSelected === 4 && action.conversation.chat.completed === false)//open inquiries
    ) {
        let isAgentExist = false
        action.conversation.chat.agentName.forEach(agent => {
            if (agent.agent === action.agentName) {
                isAgentExist = true
            }
        })
        // convarr=convarr.concat([action.conversation.chat])
        if (isAgentExist || action.chatTypeSelected === 1
            ||
            (action.chatTypeSelected === 7 && action.isAgentOnConvGroups)
            ||
            action.chatTypeSelected === 6 // all inquiries
            ||
            (action.chatTypeSelected === 5 && action.conversation.chat.completed === true) // all closed inquiries
            ||
            (action.chatTypeSelected === 4 && action.conversation.chat.completed === false)//open inquiries
        ) {
            convarr.unshift(action.conversation.chat);
        }

    }
    return updateObject(state, {
        conversations: convarr,
        selectedConv: !updatedSelectedConv ? state.selectedConv : updatedSelectedConv,
        chatSelectedSenderName: chatSelectedSenderName,
        chatSelectedChannel: chatSelectedChannel
    })
}

const newConversation = (state, action) => {
    // console.log('here123')
    // console.log(action.conversation)
    let newConvsArray = [...state.conversations]
    // if (state.isPublic === action.conversation.chat.isPublic && state.completed === action.conversation.chat.completed) {
    // console.log('here123')
    // newConvsArray = newConvsArray.concat([action.conversation.chat])
    const isSameConv = newConvsArray.find(conv => {
        return conv._id === action.conversation.chat._id
    })
    if (!isSameConv) {
        newConvsArray.unshift(action.conversation.chat);
    }

    // }
    return updateObject(state, {
        conversations: newConvsArray
    })
}

const deleteManyChats = (state, action) => {
    console.log('deleteManyChats')
    const convsCopy = [...state.conversations]
    const msgsCopy = [...state.msgs]
    let newConvs = convsCopy
    let newMsgs = msgsCopy
    let newSelectedConv = state.selectedConv
    let newChatSelectedChannel = state.chatSelectedChannel
    let newChatSelectedSenderName = state.chatSelectedSenderName
    console.log('deleteManyChats2')
    if (action.filters.chatTypesFilter && action.filters.chatTypesFilter.length > 0) {
        console.log('deleteManyChats3')
        newConvs = convsCopy.filter(conv => !action.filters.chatTypesFilter.includes(conv.msgType))
        if (state.selectedConv && action.filters.chatTypesFilter.includes(state.selectedConv.msgType)) {
            newSelectedConv = undefined
            console.log('deleteManyChats4')
        }
        if (state.chatSelectedChannel && action.filters.chatTypesFilter.includes(state.chatSelectedChannel)) {
            newChatSelectedChannel = undefined
            newChatSelectedSenderName = undefined
            console.log('deleteManyChats5')
        }
        newMsgs = msgsCopy.filter(msg => !action.filters.chatTypesFilter.includes(msg.msgType))
    }

    console.log('deleteManyChats6')
    return updateObject(state, {
        conversations: newConvs,
        msgs: newMsgs,
        selectedConv: newSelectedConv,
        chatSelectedChannel: newChatSelectedChannel,
        chatSelectedSenderName: newChatSelectedSenderName
    })
}

const clearMsgs = (state, action) => {
    return updateObject(state, {
        msgs: [],
        chatSelectedSenderName: null,
        chatSelectedChannel: null,
        selectedConv: undefined
    })
}

const deleteChatRecived = (state, action) => {
    console.log('action.chatTypeSelected=' + action.chatTypeSelected)
    let convarr = [...state.conversations];
    const i = convarr.findIndex(conv => (
        conv.clientName === action.chat.clientName && conv.msgType === action.chat.msgType//dima
    ));
    if (convarr[i] &&
        (
            !(
                (action.chatTypeSelected === 4 && action.chat.completed === false)
                ||
                (action.chatTypeSelected === 5 && action.chat.completed === true)
                ||
                action.chatTypeSelected === 6
            )
            ||
            action.isCompletelyDelete)
    ) {
        convarr.splice(i, 1);
    }
    return updateObject(state, {
        conversations: convarr
    })
}

const setCategory = (state, action) => {
    // console.log('12233')
    // console.log(action)
    return updateObject(state, {
        isPublic: action.isPublic,
        completed: action.completed
    })
}

const initCategoryMsgUnSeenStatus = (state, action) => {
    //console.log(action)
    return updateObject(state, {
        categoryUnSeenMsgsStatus: { newInquiries: action.CategoryMsgUnSeenObj.newInquiries, inProgressInquiries: action.CategoryMsgUnSeenObj.inProgressInquiries, allAgentInquiries: action.CategoryMsgUnSeenObj.allAgentInquiries }
    })
}

const updateCategoryMsgUnSeenStatus = (state, action) => {
    let categoryUnSeenMsgsStatus = JSON.parse(JSON.stringify(state.categoryUnSeenMsgsStatus))
    categoryUnSeenMsgsStatus.newInquiries = categoryUnSeenMsgsStatus.newInquiries + action.categoryUnSeenStatusUpdateObj.newInquiries
    categoryUnSeenMsgsStatus.inProgressInquiries = categoryUnSeenMsgsStatus.inProgressInquiries + action.categoryUnSeenStatusUpdateObj.inProgressInquiries
    categoryUnSeenMsgsStatus.allAgentInquiries = categoryUnSeenMsgsStatus.allAgentInquiries + action.categoryUnSeenStatusUpdateObj.allAgentInquiries
    return updateObject(state, {
        categoryUnSeenMsgsStatus: categoryUnSeenMsgsStatus
    })
}

const multiSelectUnselectChat = (state, action) => {
    let convarr = [...state.conversations]
    let multiSelectCount = state.multiSelectCount
    const chatIndex = convarr.findIndex(conv => (
        conv.clientName === action.clientName && conv.msgType === action.msgType//dima
    ))
    if (chatIndex < 0) {
        //do nothing
    }
    else {
        convarr[chatIndex].isChatMultiSelected = !convarr[chatIndex].isChatMultiSelected
        if (convarr[chatIndex].isChatMultiSelected) {
            multiSelectCount++
        }
        else {
            multiSelectCount--
        }
    }

    return updateObject(state, {
        multiSelectCount: multiSelectCount,
        conversations: convarr
    })
}
const multiSelectUnselectAllChat = (state, action) => {
    let convarr = [...state.conversations]
    let multiSelectCount = undefined
    if (action.selectType === 'selectall') {
        convarr.forEach(conv => {
            conv.isChatMultiSelected = true
        })
        multiSelectCount = convarr.length
    }
    else {
        convarr.forEach(conv => {
            conv.isChatMultiSelected = false
        })
        multiSelectCount = 0
    }
    return updateObject(state, {
        multiSelectCount: multiSelectCount,
        conversations: convarr
    })
}

const insertChatContact = (state, action) => {
    const copyConvs = JSON.parse(JSON.stringify(state.conversations))
    const email = action.contact.email
    const mainPhone = action.contact.mainPhone.startsWith('0') ? action.contact.mainPhone.replace('0', '+972') : action.contact.mainPhone
    copyConvs.forEach((conv) => {
        if (!conv.contactId) { //add contact only if not exist on conv
            if (conv.clientName === mainPhone || conv.clientName === email) {
                conv.contactId = action.contact
            }
        }
    })

    let newSelectedConv = state.selectedConv ? JSON.parse(JSON.stringify(state.selectedConv)) : undefined
    if ((newSelectedConv && (state.selectedConv?.clientName === mainPhone || state.selectedConv?.clientName === email))) {
        newSelectedConv.contactId = action.contact
    }

    return updateObject(state, {
        conversations: copyConvs,
        selectedConv: newSelectedConv
    })
}

const updateChatContact = (state, action) => {
    const copyConvs = JSON.parse(JSON.stringify(state.conversations))
    const email = action.contact.email
    const mainPhone = action.contact.mainPhone.startsWith('0') ? action.contact.mainPhone.replace('0', '+972') : action.contact.mainPhone
    copyConvs.forEach((conv) => {
        if (conv.contactId?._id === action.contact._id) {
            conv.contactId = action.contact
        }
    })

    let newSelectedConv = state.selectedConv ? JSON.parse(JSON.stringify(state.selectedConv)) : undefined
    if ((state.selectedConv?.clientName === mainPhone || state.selectedConv?.clientName === email)) {
        newSelectedConv.contactId = action.contact
    }

    return updateObject(state, {
        conversations: copyConvs,
        selectedConv: newSelectedConv
    })
}

const deleteChatContact = (state, action) => {
    const copyConvs = JSON.parse(JSON.stringify(state.conversations))

    copyConvs.forEach((conv) => {
        if (conv.contactId?._id === action.contact._id) {
            conv.contactId = null
        }
    })

    return updateObject(state, {
        conversations: copyConvs
    })
}
const reducer = (state = initState, action) => {

    switch (action.type) {
        case actionType.FETCH_MSGS_START: return fetchMsgStart(state, action);
        case actionType.FETCH_MSGS_SUCCESS: return fetchMsgSuccess(state, action);
        case actionType.FETCH_MSGS_FAIL: return fetchMsgFail(state, action);
        case actionType.FETCH_CHATS_START: return fetchChatStart(state, action);
        case actionType.FETCH_CHATS_SUCCESS: return fetchChatSuccess(state, action);
        case actionType.FETCH_CHAT_UPDATE_CRM_DATA_SUCCESS: return fetchChatUpdatedCrmDataSuccess(state, action);
        case actionType.FETCH_CHATS_FAIL: return fetchChatFail(state, action);
        case actionType.SEND_MSGS_START: return sendMsgStart(state, action);
        case actionType.SEND_MSGS_SUCCESS: return sendMsgSuccess(state, action);
        case actionType.SEND_MSGS_FAIL: return sendMsgFail(state, action);
        case actionType.LOGOUT_SUCCESS: return logout(state, action);
        // case actionType.CHAT_SELECTED: return chatSelected(state, action);
        case actionType.NEW_MSG_RECIVED: return newMsgRecived(state, action);
        case actionType.UPDATE_CONVERSATION: return updateConversations(state, action);
        case actionType.NEW_CONVERSATION: return newConversation(state, action);
        case actionType.UPDATE_MSG_RECIVED: return updateMsgRecived(state, action);
        case actionType.DELETE_MSG_RECIVED: return deleteMsgRecived(state, action);
        case actionType.CLEAR_MSGS: return clearMsgs(state, action);
        case actionType.DELETE_CHAT_RECIVED: return deleteChatRecived(state, action);
        case actionType.SET_CATEGORY: return setCategory(state, action);
        case actionType.INIT_CATEGORY_MSG_UNSEEN_STATUS: return initCategoryMsgUnSeenStatus(state, action);
        case actionType.UPDATE_CATEGORY_MSG_UNSEEN_STATUS: return updateCategoryMsgUnSeenStatus(state, action);
        case actionType.CHAT_UNSELECT: return chatUnSelected(state, action);
        case actionType.MULTI_SELECT_UNSELECT_CHAT: return multiSelectUnselectChat(state, action);
        case actionType.MULTI_SELECT_UNSELECT_ALL_CHAT: return multiSelectUnselectAllChat(state, action);
        case actionType.DELETE_MANY_CHATS: return deleteManyChats(state, action);
        case actionType.SELECT_MSG: return selectMsg(state, action);
        case actionType.INSERT_CHAT_CONTACT: return insertChatContact(state, action);
        case actionType.UPDATE_CHAT_CONTACT: return updateChatContact(state, action);
        case actionType.DELETE_CHAT_CONTACT: return deleteChatContact(state, action);
        default:
            return state
    }
}

export default reducer;